import { useEffect } from "react";

import { IDropdownOption, useFieldContext } from "@bps/fluent-ui";
import { SoftwarePackageVersion } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { SoftwarePackageVersionDropDown } from "../../../../common/SoftwarePackageVersionDropDown";
import { SelectSoftwarePackageFormValues } from "../selectSoftwarePackageUtils";

export interface SelectSoftwarePackageVersionDropDownProps {
  selection: any;
  softwarePackageVersions: SoftwarePackageVersion[];
  onUpdateSoftwarePackageVersion: (
    softwarePackageId: string,
    softwarePackageVersionId: string
  ) => void;
}

export const SelectSoftwarePackageVersionDropDown = ({
  selection,
  softwarePackageVersions,
  onUpdateSoftwarePackageVersion
}: SelectSoftwarePackageVersionDropDownProps) => {
  const { value: packages, setFieldValue } = useFieldContext<
    SelectSoftwarePackageFormValues[]
  >("packages");

  const versionOptions =
    softwarePackageVersions.map(x => {
      return {
        key: x.id,
        text: x.version as string,
        data: x
      } as IDropdownOption;
    }) ?? [];

  const defaultSelection =
    versionOptions.length > 0 ? (versionOptions[0].key as string) : undefined;

  const selectedKey = selection?.softwarePackageVersionId ?? defaultSelection;

  // If we don't have a version set for the row, set it once we have the versions and a selected key
  useEffect(() => {
    if (!softwarePackageVersions) return;
    if (!packages) return;
    if (!selection) return;

    const packageFormData = packages.find(
      x => x.softwarePackageId === selection.softwarePackageId
    );

    if (!packageFormData) return;
    if (packageFormData.softwarePackageVersionId) return;

    const updatedPackages = packages.map(x => {
      return x.softwarePackageId === selection.softwarePackageId
        ? {
            ...x,
            softwarePackageVersionId: selectedKey
          }
        : x;
    });

    setFieldValue(updatedPackages);
  }, [
    softwarePackageVersions,
    packages,
    selectedKey,
    selection,
    setFieldValue
  ]);

  return (
    <SoftwarePackageVersionDropDown
      selectedKey={selectedKey}
      name="softwarePackageVersionId"
      options={versionOptions}
      onChange={(_e, option) =>
        onUpdateSoftwarePackageVersion(
          selection.softwarePackageId,
          String(option?.key)
        )
      }
    />
  );
};
